<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner';

interface Props {
  /**
   * Centers the spinner horizontally if true
   */
  centerX?: boolean;
  /**
   * Centers the spinner vertically if true
   */
  centerY?: boolean;
  /**
   * Custom size in pixels
   */
  size?: number;
  /**
   * Loading text to display below spinner
   */
  text?: string;
  /**
   * Custom stroke width
   */
  strokeWidth?: number;
  /**
   * Animation duration in seconds
   */
  animationDuration?: number;
  /**
   * Margin top in pixels
   */
  mt?: boolean;
  /**
   * Margin bottom in pixels
   */
  pb?: boolean;
}

withDefaults(defineProps<Props>(), {
  centerX: true,
  centerY: true,
  mt: true,
  size: 50,
  strokeWidth: 2,
  animationDuration: 2,
  pb: true,
});
</script>

<template>
  <div
    class="loading-container"
    :class="{
      'justify-center': centerX,
      'items-center': centerY,
      'h-full': centerY,
      'mt-24': mt,
      'pb-24': pb,
    }"
  >
    <div class="flex flex-col items-center gap-2">
      <ProgressSpinner
        :style="{ width: `${size}px`, height: `${size}px` }"
        :strokeWidth="strokeWidth.toString()"
        :animationDuration="`${animationDuration}s`"
        aria-label="Loading"
      />
      <span v-if="text" class="text-sm text-gray-600">{{ text }}</span>
    </div>
  </div>
</template>

<style scoped>
.loading-container {
  display: flex;
  width: 100%;
}
</style>
